import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { NoteEntityType } from '../model/note';

export interface CreateParentParams {
  entityId: string;
  entityType: NoteEntityType;
  note: string;
  studioId: string;
}

export const createNote = async (params: CreateParentParams) => {
  const response = await baseAPI.post<unknown>('/notes/add', params);

  return response.data;
};

export const useCreateNoteMutation = () => {
  return useMutation({
    mutationFn: createNote,
    onSuccess() {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.NOTES],
      });
    },
    onError() {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.NOTES],
      });
    },
  });
};
